import Aragon from './aragon';

export default {
  Aragon
};
